export default __webpack_public_path__ + "static/media/lottery.0d62d76c.webp";